import React, { ReactNode } from 'react'
import Button from 'app/modules/shared/components/button'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'

interface ErrorLayoutProps {
  buttonId: string
  code: string | number
  message: ReactNode
  note?: ReactNode
  onReset?: () => void
}

export function ErrorLayout({ buttonId, code, message, note, onReset }: ErrorLayoutProps): JSX.Element {
  const { _t } = useTypedTranslation()

  return (
    <div className="container-fluid main-container">
      <div className="centered-layout error-page">
        <div className="error-box">
          <div className="error-code">{code}</div>
          <div className="error-message">{message}</div>
          {note && <div className="error-note text-muted text-center mb-4">{note}</div>}
          {onReset && (
            <Button id={buttonId} variant="primary" onClick={onReset}>
              {_t('go-back')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
